import { createSlice } from '@reduxjs/toolkit'
import { CallInteractionState } from '../types/callInteraction.type'

const initialState: CallInteractionState = {
  attributes: {
    call_recording_consent: { name: '', value: '' },
    channel: { name: '', value: '' },
    client_id: { name: '', value: '' },
    contact_id: { name: '', value: '' },
    customer_callback_number: { name: '', value: '' },
    customer_phone: { name: '', value: '' },
    first_name: { name: '', value: '' },
    ivr_menu_followed: { name: '', value: '' },
    language: { name: '', value: '' },
    last_name: { name: '', value: '' },
    program_id: { name: '', value: '' },
    resources_id: { name: '', value: '' },
    service_id: { name: '', value: '' },
    xyz: { name: '', value: '' },
    pick_time: { name: '', value: '' },
    agent_id: { name: '', value: '' },
  },
  availability: null,
}

const callInteractionSlice = createSlice({
  name: 'callInteraction',
  initialState,
  reducers: {
    setCallAttributes(state, { payload }) {
      state.attributes = payload
    },
    setAvailability(state, { payload }) {
      state.availability = payload
    },
  },
})

export const { setCallAttributes, setAvailability } =
  callInteractionSlice.actions

export default callInteractionSlice.reducer
